import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCourses } from "../../redux/slice/courseSlice"; // Importing getCourses action
import { getDroneCategory } from "../../redux/slice/droneCategorySlice"; // Importing droneCategory action
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import PlaceIcon from '@mui/icons-material/Place';
import "react-toastify/dist/ReactToastify.css"; // Toastify styles
import image1 from '../../assets/image/png/peopellers.jpg';
import image2 from '../../assets/image/png/controller.jpg';
import image3 from '../../assets/image/png/accessories.jpg';
import image4 from '../../assets/image/png/Motor2.jpg';
import bannerImage1 from "../../assets/image/png/drone-flying-city-1 1 (1).png";
import bannerImage2 from "../../assets/image/png/Enlist-Your-Company.png"; // Add your own image paths
import bannerImage3 from "../../assets/image/png/Drone-Repair 4.png";
import bannerImage4 from "../../assets/image/png/drone-flying-city-1 1 (1).png"; 
import bg from "../../assets/image/png/1267.jpg"; // Add your own image paths// Add your own image paths
import loction_icon from "../../assets/image/png/loction.png";
import date_icon from "../../assets/image/png/date_ivon.png";
import SearchIcon from "../../assets/image/svg/search_icon.svg";
import Hawk from "../../assets/image/png/Hawk Drone.png";
import Hawk1 from "../../assets/image/png/Hawk-1.png";
import Hawk2 from "../../assets/image/png/Hawk-2.png";
import Viraj from "../../assets/image/png/viraj drone.png";
import Viraj1 from "../../assets/image/png/front view.png";
import Viraj2 from "../../assets/image/png/back sidew.png";
import icons from "../../assets/image/png/Water ResistanceIcon.png";
import icons1 from "../../assets/image/png/Icon-0.png";
import icons2 from "../../assets/image/png/Icon-1.png";
import icons3 from "../../assets/image/png/Icon-2.png";
import icons4 from "../../assets/image/png/Icon-3.png";
import icons5 from "../../assets/image/png/Icon-4.png";
import weight from "../../assets/image/png/weight.jpg";
import distance from "../../assets/image/png/distance.jpg";
import transpower from "../../assets/image/png/transpower.jpg";
import StoreIcon from "@mui/icons-material/Store";
import HelicopterIcon from "@mui/icons-material/Toys"; // You can replace with a drone SVG
import SchoolIcon from "@mui/icons-material/School";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import HandshakeIcon from "@mui/icons-material/Handshake";
import BuildIcon from "@mui/icons-material/Build";
import Taas from "../../assets/image/png/Taas1.png";
import drone from "../../assets/image/png/drone.png";
import dronepart from "../../assets/image/png/droneparts.png";
import careers from "../../assets/image/png/careers.png";
import daas from "../../assets/image/png/daass.png";
import training from "../../assets/image/png/institute.png";
import course from "../../assets/image/png/courses.png";
import taas from "../../assets/image/png/taas.png";
import workshop from "../../assets/image/png/workshop.png";
import dronexplore from "../../assets/image/png/virtual-machine_18168913.png";
import droneImg from "../../assets/image/png/drones_compressed.avif";
import dronePartImg from "../../assets/image/png/drone-parts_compressed.avif";
import careersImg from "../../assets/image/png/careers_compressed.avif";
import daasImg from "../../assets/image/png/daas_compressed.avif";
import trainingImg from "../../assets/image/png/drone-training_compressed.avif";
import courseImg from "../../assets/image/png/courses_compressed.avif";
import taasImg from "../../assets/image/png/tender_compressed.avif";
import workshopImg from "../../assets/image/png/workshop_compressed.avif";
import dronexploreImg from "../../assets/image/png/droneXplore_compressed.avif";
import Marketpalace from "../../assets/image/png/Marketpalace1.png";
import Workshop from "../../assets/image/png/Workshop1.png";
import Dronetraining from "../../assets/image/png/Dronee1.png";
import Daas from "../../assets/image/png/DaaS.png";
import Course from "../../assets/image/png/Course1.png";
import HomeNavbar from '../homepage/HomeNavbar';
import axios from "axios";
import CountUp from "react-countup";

import { Link } from "react-router-dom";
import Slider from "react-slick";
import { Box, Button, Card, CardContent, CardMedia, Container, Dialog, DialogContent, Divider, Grid, List, ListItem, ListItemText, Paper, TextField, Typography, IconButton, Chip  } from "@mui/material";
 // Replace with actual image path
import virajDroneVideo from '../../assets/video/viraj drone 22.mp4';
import hawkDroneVideo from '../../assets/video/HAWK Videos 1_1.mp4';
import myVideo from "../../assets/video/video6219820317779433055.mp4";
import CourseRecommendation from '../droneshala/CourseRecommendation';
import { getInstitutes } from "../../redux/slice/instituteSlice";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import "remixicon/fonts/remixicon.css"; // Ensure Remix Icon CSS is included
import HPDronee from "../../assets/image/png/HPDrone.jpeg"
import SaaS from "../../assets/image/png/SaaS.jpg"
import { useMediaQuery, useTheme } from '@mui/material';
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { keyframes } from '@emotion/react';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import StarIcon from '@mui/icons-material/Star';
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import MemoryIcon from "@mui/icons-material/Memory";
import WorkIcon from "@mui/icons-material/Work";
import FactoryIcon from "@mui/icons-material/Factory";

// const floatAnimation = keyframes`
//   0% { transform: translateY(0px) rotate(0deg); }
//   50% { transform: translateY(-15px) rotate(2deg); }
//   100% { transform: translateY(0px) rotate(0deg); }
// `;

// const pulseAnimation = keyframes`
//   0% { box-shadow: 0 0 0 0 rgba(66, 165, 245, 0.4); }
//   70% { box-shadow: 0 0 0 15px rgba(66, 165, 245, 0); }
//   100% { box-shadow: 0 0 0 0 rgba(66, 165, 245, 0); }
// `;

// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(40px); }
//   to { opacity: 1; transform: translateY(0); }
// `;

// const droneFloat = keyframes`
//   0% { transform: translateY(0) rotate(0deg); }
//   33% { transform: translateY(-10px) rotate(1deg); }
//   66% { transform: translateY(5px) rotate(-1deg); }
//   100% { transform: translateY(0) rotate(0deg); }
// `;

// const shineEffect = keyframes`
//   0% { left: -100%; }
//   20% { left: 100%; }
//   100% { left: 100%; }
// `;

// New animations
// const scaleIn = keyframes`
//   from { transform: scale(0.9); opacity: 0; }
//   to { transform: scale(1); opacity: 1; }
// `;

gsap.registerPlugin(ScrollTrigger);
// const mediaCoverage = [
//   {
//     image: Viraj2,
//     link: "https://timestech.in/drone-planet-aims-to-unify-indias-drone-ecosystem-with-ai-skilling/"
//   },
//   {
//     image: Hawk2,
//     link: "http://cxotoday.com/story/top-7-emerging-brands-that-are-pioneering-next-gen-solutions/"
//   },
//   {
//     image: Hawk,
//     link: "http://cxotoday.com/story/top-7-emerging-brands-that-are-pioneering-next-gen-solutions/"
//   }
// ];

// const sliderSettings = {
//   dots: false,
//   infinite: true,
//   speed: 3000,
//   autoplay: true,
//   autoplaySpeed: 2000,
//   slidesToShow: 4,
//   slidesToScroll: 1,
//   arrows: false,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: { slidesToShow: 3 }
//     },
//     {
//       breakpoint: 600,
//       settings: { slidesToShow: 2 }
//     },
//     {
//       breakpoint: 480,
//       settings: { slidesToShow: 1 }
//     }
//   ]
// };

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  arrows: false,
};

const BuyCertifiedDrone = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { droneCategory } = useSelector((state) => state.droneCategory);
  const { courses } = useSelector((state) => state.course); // Fetching courses data from Redux store
  const [sort, setSort] = useState("asc"); // Example sorting state
  const [search, setSearch] = useState(""); // Example search state
  const [locationSearch, setLocationSearch] = useState(""); // Example location search state  
  const [partners, setPartner] = useState([]);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [page, setPage] = useState(1);
  // const dispatch = useDispatch();
  // const [page, setPage] = useState(1);
  const { totalPage, institutes } = useSelector((state) => state.institute);
  const { id } = useParams();
  const [currentSlide, setCurrentSlide] = useState(0);
  const [hawkImageIndex, setHawkImageIndex] = useState(0);
  const [virajImageIndex, setVirajImageIndex] = useState(0);
  const [activeTab, setActiveTab] = useState(id);
  const [showInstitutes, setShowInstitutes] = useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // State for search query
  const [filteredInstitutes, setFilteredInstitutes] = useState([]); // Filtered institutes
  const [allInstitutes, setAllInstitutes] = useState([]); // Store all institutes here
  const [quizStarted, setQuizStarted] = useState(false); // State to manage button visibility
  const [selectedDrone, setSelectedDrone] = useState('hawk'); // State to keep track of selected drone
  const [activeCard, setActiveCard] = useState(0);
  const [showHeadings, setShowHeadings] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [favorites, setFavorites] = useState({});
  const sectionRef = useRef(null);
  const [metrics, setMetrics] = useState({
  drones: 0,
  droneParts: 0,
  jobs: 0,
  rptos: 0,
  manufacturers: 0,
});

const [loadingMetrics, setLoadingMetrics] = useState(true);

useEffect(() => {
  const fetchMetrics = async () => {
    try {
      const res = await axios.get(
        process.env.REACT_APP_API_URL + "/metrics"      );

      if (res.data?.success) {
        setMetrics(res.data.data);
      }
    } catch (error) {
      console.error("Failed to fetch metrics", error);
    } finally {
      setLoadingMetrics(false);
    }
  };

  fetchMetrics();
}, []);


  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const toggleFavorite = (id, event) => {
    event.stopPropagation();
    setFavorites(prev => ({ ...prev, [id]: !prev[id] }));
  };
  useEffect(() => {
    setIsVisible(true);
  }, []);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const hawkImages = [Hawk, Hawk1, Hawk2];
  const virajImages = [Viraj, Viraj1, Viraj2];
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  useEffect(() => {
    const checkWidth = () => {
      setIsVisible(window.innerWidth > 1000);
    };

    checkWidth(); // run on mount
    window.addEventListener("resize", checkWidth);

    return () => window.removeEventListener("resize", checkWidth);
  }, []);

  const handleClick = () => {
    setQuizStarted(true); // Hide the "Start Quiz" button
    window.location.href = '/droneshalaa'; // Redirect to the quiz page
  };
  useEffect(() => {
    dispatch(getInstitutes({ page: page }));
  }, [page, dispatch]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (selectedDrone === 'hawk') {
        setHawkImageIndex((prevIndex) => (prevIndex + 1) % hawkImages.length);
      } else {
        setVirajImageIndex((prevIndex) => (prevIndex + 1) % virajImages.length);
      }
    }, 3000);

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [selectedDrone]);
  useEffect(() => {
    setActiveTab(id);
    setShowInstitutes(id === "1");
    window.scrollTo(0, 0);
  }, [id]);

//   useEffect(() => {

//   const mm = gsap.matchMedia();

//   // Desktop / Tablet (3 cards per row)
//   mm.add("(min-width: 768px)", () => {
//     const rows = gsap.utils.toArray(".c-card-row");
//     const lastRowIndex = rows.length - 1;

//     const lastRowST = ScrollTrigger.create({
//       trigger: rows[rows.length - 1],
//       start: "center center",
//     });

//     rows.forEach((row, index) => {
//       const scale = index === lastRowIndex ? 1 : 0.85;
//       const scaleDown = gsap.to(row, { scale: scale });

//       ScrollTrigger.create({
//         trigger: row,
//         start: "top top",
//         end: () => lastRowST.start,
//         pin: true,
//         pinSpacing: false,
//         scrub: 0.5,
//         ease: "none",
//         animation: scaleDown,
//         toggleActions: "restart none none reverse",
//       });
//     });
//   });

//   // Mobile (each card acts like a row)
//   mm.add("(max-width: 767px)", () => {
//     const cards = gsap.utils.toArray(".c-card"); // target individual cards
//     const lastCardIndex = cards.length - 1;

//     const lastCardST = ScrollTrigger.create({
//       trigger: cards[cards.length - 1],
//       start: "center center",
//     });

//     cards.forEach((card, index) => {
//       const scale = index === lastCardIndex ? 1 : 0.85;
//       const scaleDown = gsap.to(card, { scale: scale });

//       ScrollTrigger.create({
//         trigger: card,
//         start: "top top",
//         end: () => lastCardST.start,
//         pin: true,
//         pinSpacing: false,
//         scrub: 0.5,
//         ease: "none",
//         animation: scaleDown,
//         toggleActions: "restart none none reverse",
//       });
//     });
//   });

//   return () => {
//     mm.revert(); // cleanup all scroll triggers
//   };
// }, []);


  // Update allInstitutes only when new data is fetched
  useEffect(() => {
    if (institutes.length > 0) {
      // Append newly fetched institutes to the allInstitutes array
      setAllInstitutes((prevInstitutes) => [ ...institutes]);
    }
  }, [institutes]);

useEffect(() => {
  let ctx = gsap.context(() => {
    const cards = gsap.utils.toArray(".big-card");
    if (!cards.length) return;

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".big-cards",
        pin: true,
        scrub: 0.6,
        start: "top-=150",
        end: "+=1500",
        onEnter: () => setShowHeadings(true),
        onLeave: () => setShowHeadings(false),
        onEnterBack: () => setShowHeadings(true),
        onLeaveBack: () => setShowHeadings(false),
        onUpdate: (self) => {
          const index = Math.round(self.progress * (cards.length - 1));
          setActiveCard(index);

          cards.forEach((c, i) => {
            c.style.pointerEvents = i === index ? "auto" : "none";
          });
        },
      },
      defaults: { ease: "power2.out", duration: 0.8 },
    });

    cards.forEach((card, i) => {
      if (i === 0) {
        tl.fromTo(card, { yPercent: 0, opacity: 1 }, { yPercent: 0, opacity: 1 });
      } else {
        tl.from(card, {
          yPercent: 80,
          opacity: 0,
          scale: 0.95,
          ease: "power2.out",
          duration: 1.2,
        });
        tl.to(
          cards[i - 1],
          {
            scale: 0.96,
            yPercent: -10,
            opacity: 0.6,
            ease: "power1.out",
            duration: 1.2,
          },
          "<"
        );
        tl.to(
          card,
          {
            yPercent: 0,
            opacity: 1,
            scale: 1,
            ease: "power2.out",
            duration: 1.2,
          },
          "<0.3"
        );
      }
    });

    ScrollTrigger.refresh(); // ensure correct positions after mount
  });

  return () => ctx.revert(); // safely clean everything this effect created
}, []);




  useEffect(() => {
  const filtered = allInstitutes.filter((institute) => {
    const name = institute?.instituteName?.toLowerCase() || "";
    const query = searchQuery?.toLowerCase() || "";

    return name.includes(query);
  });

  setFilteredInstitutes(filtered);
}, [searchQuery, allInstitutes]);

  const handleSelect = (key) => {
    setActiveTab(key);
    setShowInstitutes(key === "1");
    navigate(`/training-courses/${key}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const searchHandle = (e) => {
    e.preventDefault();
    setPage(1);
    dispatch(getCourses({ page: 1, sort, search, location: locationSearch }));
  };

  // Function to handle sorting and filtering courses based on the selected option
  const sortedCourses = () => {
    if (!courses) return [];
    let filteredCourses = [...courses];

    // Filter by location
    if (locationSearch) {
      filteredCourses = filteredCourses.filter(course =>
        course.locationName.toLowerCase().includes(locationSearch.toLowerCase())
      );
    }

    // Sort based on selected sort option
    switch (sort) {
      case "priceAsc":
        filteredCourses.sort((a, b) => a.price - b.price);
        break;
      case "priceDesc":
        filteredCourses.sort((a, b) => b.price - a.price);
        break;
      case "newest":
        filteredCourses.sort((a, b) => new Date(b.courseStartDate) - new Date(a.courseStartDate));
        break;
      case "discount":
        filteredCourses.sort((a, b) => (b.discount || 0) - (a.discount || 0)); // Assuming `discount` is a field in your course object
        break;
      default:
        break;
    }

    return filteredCourses.slice(0); // Return the sorted and limited courses
  };
  useEffect(() => {
    dispatch(getDroneCategory(1)); // Fetch drone categories
    dispatch(getCourses({ sort, search, location: locationSearch, limit: 5 })); // Fetch courses with a limit of 5
}, [dispatch, sort, search, locationSearch]); // `limit` can be removed from dependencies since it's constant

  // Handle course card click (navigate to course detail page)
  const handleCourseClick = (courseId) => {
    navigate(`/course/${courseId}`);
  };
 const handleCategoryClick = (classificationName) => {
    navigate(`/drone-parts?classification=${classificationName}`);
  };
  
const services = [
  {
    icon: drone,
    title: "Drones",
    description:
      "We offer carefully screened top-brand drones, ensuring reliability, right pricing, and smart value for every drone buyer",
    link: "/product/all-drone",
    image: droneImg, // ✅ background image
  },
  {
    icon: dronepart,
    title: "Drone Parts",
    description:
      "We offer carefully screened top-brand drone parts, ensuring reliability, perfect compatibility,  adaptability and interchangeability with t right price for long-term performance",
    link: "/drone-parts",
    image: dronePartImg,
  },
  {
    icon: dronexplore,
    title: "SaaS Store",
    description:
      "Access trusted, cloud-based Software as a Service (SaaS) tool from top brands, thoughtfully curated for reliability and smart subscription value",
    link: "/intellegence-market-solutions",
    image: dronexploreImg,
  },
  // hidden for payment gateway
  {
    icon: daas,
    title: "DaaS Store",
    subtitle: "( Drone as Service )",
    description:
      "Access premium Drone-as-a-Service (DaaS) solutions from trusted brands, delivering expert-operated, cost-efficient drone services at optimal value",
    link: "/daas-service-page",
    image: daasImg,
  },
  {
    icon: taas,
    title: "TaaS Store",
    subtitle: "( Tender as a Service )",
    description:
      "Discover Drone Tender as a Service (TaaS) to find, manage, and win government and private drone tenders efficiently",
    link: "/taas",
    image: taasImg,
  },
  {
    icon: careers,
    title: "Career in Drones",
    description:
      "Explore verified career opportunities across the drone ecosystem, connect with trusted employers, and build a future-ready professional path",
    link: "/jobs-hire-page",
    image: careersImg,
  },
  {
    icon: training,
    title: "Drone Training",
    description:
      "Get DGCA-approved drone certification through RPTOs and gain industry-recognized skills, legal eligibility, and career-ready pilot credentials",
    link: "/training-courses/1",
    image: trainingImg,
  },
  {
    icon: workshop,
    title: "Workshops",
    description:
      "Join hands-on drone workshops that build real-world skills, industry exposure, and practical expertise for ambitious learners and professionals",
    link: "/training-courses/2",
    image: workshopImg,
  },
  {
    icon: course,
    title: "Certified Drone Courses",
    description:
      "Access expertly curated drone training programs designed to build industry-ready skills and unlock real career and business opportunities",
    link: "/training-courses/0",
    image: courseImg,
  },
  
  
];
const headings = ["Marketplace", "Services", "Training"];
const rows = services.reduce((acc, service, index) => {
    if (index % 3 === 0) acc.push([]);
    acc[acc.length - 1].push(service);
    return acc;
  }, []);

const chunkedServices = [];
  for (let i = 0; i < services.length; i += 3) {
    chunkedServices.push(services.slice(i, i + 3));
  }

  return (
    <div className="buy-certified-drone-background pt-0">
      {/* <ToastContainer /> */}
      <div className="container-fluid p-0">
      {/* <Box sx={{ my: 3 }}>
      <Grid container spacing={2} justifyContent="center" alignItems="center">
        <Grid item xs={12} sx={{ textAlign: 'center', mb: 3 }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
  <Box
    sx={{
      textAlign: 'center',
      paddingBottom: '5px',
      borderBottom: selectedDrone === 'hawk' ? '3px solid #1976d2' : 'none',
      marginRight: 2,
      cursor: 'pointer',
      fontSize: '24px', // Increased font size
      fontWeight: 'bold', // Make it bolder
      '&:hover': { borderBottom: '3px solid #1976d2' },
    }}
    onClick={() => setSelectedDrone('hawk')}
  >
    Hawk Drone
  </Box>

  <Box sx={{ mx: 2, fontSize: '28px', fontWeight: 'bold' }}>|</Box>

  <Box
    sx={{
      textAlign: 'center',
      paddingBottom: '5px',
      borderBottom: selectedDrone === 'viraj' ? '3px solid #1976d2' : 'none',
      marginLeft: 2,
      cursor: 'pointer',
      fontSize: '24px', // Increased font size
      fontWeight: 'bold', // Make it bolder
      '&:hover': { borderBottom: '3px solid #1976d2' },
    }}
    onClick={() => setSelectedDrone('viraj')}
  >
    Viraj Drone
  </Box>
</Box>

        </Grid>

        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', my: 5, height: '300px' }}>
  <Box sx={{
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    mr: { xs: 1, sm: 5 }, // Reduce right margin on mobile view
    ml: { xs: 2, sm: 5 }, // Optional: reduce left margin for mobile view
  }}>
    <Box sx={{ mb: 1 }}>
      <img 
        src={selectedDrone === 'hawk' ? icons1 : weight } 
        alt="Drone Icon" 
        style={{ height: '50px', width: '50px', objectFit: 'contain' }} 
      />
    </Box>

    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? 'Wifi' : '10kg Capacity'}
    </Typography>
    <Divider sx={{ my: 2, borderColor: 'black', width: '80%' }} />

    <Box sx={{ mb: 1 }}>
      <img src={selectedDrone === 'hawk' ? icons2 : distance } alt="Icon 2" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
    </Box>
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? '120° Wide Angle Lens' : '1km Flying Distance'}
    </Typography>
    <Divider sx={{ my: 2, borderColor: 'black', width: '80%' }} />

    <Box>
      <img src={icons3} alt="Icon 3" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
    </Box>
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? '5GHz FPV Streaming' : '2.4GHz Frequency'}
    </Typography>
  </Box>

  <Box
    sx={{
      position: 'relative',
      width: '100%',
      maxWidth: '500px',
      height: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      overflow: 'hidden', // Ensure the images don't spill out
    }}
  >
    <img
      src={selectedDrone === 'hawk' ? hawkImages[hawkImageIndex] : virajImages[virajImageIndex]}
      alt={selectedDrone === 'hawk' ? 'Hawk Drone' : 'Viraj Drone'}
      style={{
        width: '100%',
        height: 'auto',
        maxHeight: '300px',
        objectFit: 'contain',
        transition: 'all 1s ease-in-out',  // Smooth transition for image change
      }}
    />
  </Box>

  <Box sx={{
    display: 'flex', 
    flexDirection: 'column', 
    alignItems: 'center', 
    justifyContent: 'center', 
    ml: { xs: 1, sm: 5 }, // Reduce left margin on mobile view
    mr: { xs: 1, sm: 5 }, // Optional: reduce right margin for mobile view
  }}>
    <Box sx={{ mb: 1 }}>
      <img src={selectedDrone === 'hawk' ? icons4 : transpower } alt="Icon 4" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
    </Box>
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? '4K HDR' : '12v/2a Transmitter Power'}
    </Typography>
    <Divider sx={{ my: 2, borderColor: 'black', width: '80%' }} />

    <Box sx={{ mb: 1 }}>
      <img src={icons5} alt="Icon 5" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
    </Box>
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? '35 Minutes of Flight Time' : '21 Minutes of Flight Time'}
    </Typography>
    <Divider sx={{ my: 2, borderColor: 'black', width: '80%' }} />

    <Box>
      <img src={icons} alt="Icon 6" style={{ height: '50px', width: '50px', objectFit: 'contain' }} />
    </Box>
    <Typography variant="body2" sx={{ textAlign: 'center' }}>
      {selectedDrone === 'hawk' ? 'Weather-Resistant' : '8m/s Max Speed'}
    </Typography>
  </Box>
</Box>



        <Grid item xs={12}>
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center', // Space between text and button
      alignItems: 'center', // Vertically center align items
      backgroundColor: '#1976d2',
      color: 'white',
      padding: '10px 20px',
      borderRadius: '5px',
      width: '100%',
      margin: '0 auto',
      // border: '2px solid black',
      flexDirection: { xs: 'column', sm: 'row' }, // Column for mobile, row for web
      gap: { xs: '10px', sm: '40px' }, // Add gap between items in mobile view
    }}
  >
    <Typography
      variant="body1"
      sx={{
        textAlign: { xs: 'center', sm: 'left' }, // Center text in mobile view
      }}
    >
      A real drone, in real place, in real time
    </Typography>

    <Link
      to={`/product-detail/${selectedDrone === 'hawk' ? '6784b52a885de812ba69c46f' : '6784d8c1885de812ba69c722'}`}
      style={{ textDecoration: 'none' }}
    >
      <Button
        variant="contained"
        color="secondary"
        sx={{
          borderRadius: '5px',
          fontWeight: 'bold',
          padding: '8px 20px',
          backgroundColor: '#ffffff',
          color: '#000000',
          '&:hover': {
            backgroundColor: '#e0dcdc',
          },
        }}
      >
        Buy Now
      </Button>
    </Link>
  </Box>
</Grid>
      </Grid>
    </Box> */}
 {/* Featured In Section */}
{/* <Box sx={{ py: 6, backgroundColor: "#ffffff" }}>
  <Typography
    variant="h5"
    sx={{
      fontWeight: 600,
      textAlign: "center",
      mb: 3,
      color: "#222",
    }}
  >
    In the News
  </Typography>

  <Box sx={{ maxWidth: "1200px", mx: "auto", px: 2 }}>
    <Slider
      dots={false}
      infinite
      speed={2000}
      autoplay
      autoplaySpeed={3000}
      slidesToShow={3}
      slidesToScroll={1}
      arrows={false}
      responsive={[
        { breakpoint: 960, settings: { slidesToShow: 2 } },
        { breakpoint: 600, settings: { slidesToShow: 1 } }
      ]}
    >
      {mediaCoverage.map((item, index) => (
        <Box
          key={index}
          sx={{
            px: 2,
            display: "flex !important",
            justifyContent: "center",
          }}
        >
          <a href={item.link} target="_blank" rel="noopener noreferrer">
            <Box
              component="img"
              src={item.image}
              alt={`media-${index}`}
              sx={{
                maxHeight: "100px",
                width: "auto",
                objectFit: "contain",
                filter: "grayscale(100%)",
                transition: "filter 0.3s ease",
                "&:hover": {
                  filter: "grayscale(0%)",
                }
              }}
            />
          </a>
        </Box>
      ))}
    </Slider>
  </Box>
</Box> */}
      {/* ================= KEY METRICS SECTION ================= */}
<Box
  sx={{
    bgcolor: "#f8fafc",
    py: { xs: 6, md: 8 },
  }}
>
  {/* Section Title */}
  <Box textAlign="center" mb={{ xs: 5, md: 6 }} px={{ xs: 2, md: 6 }}>
    <Typography
      sx={{
        fontWeight: 700,
        fontSize: { xs: "1.8rem", md: "2.4rem" },
      }}
      color="primary"
    >
      Our Impact at a Glance
    </Typography>

    <Typography
      sx={{
        color: "#6b7280",
        mt: 1.5,
        maxWidth: 700,
        mx: "auto",
      }}
    >
      Building India’s most reliable drone ecosystem, powered by technology, talent, and profitable growth for every partner
    </Typography>
  </Box>

  {/* Proper container wrapper */}
  <Box
    sx={{
      maxWidth: 1200,
      mx: "auto",
      px: { xs: 2, md: 6 },   // ✅ equal left & right spacing
    }}
  >
    <Grid container spacing={4}>
      {[
        { label: "Verified Drone Models", value: metrics.drones, icon: <AirplanemodeActiveIcon /> },
        { label: "Genuine Drone Parts", value: metrics.droneParts, icon: <MemoryIcon /> },
        { label: "Drone Jobs Created", value: metrics.jobs, icon: <WorkIcon /> },
        { label: "DGCA Approved RPTOs", value: metrics.rptos, icon: <SchoolIcon /> },
        { label: "Manufacturers Onboarded", value: metrics.manufacturers, icon: <FactoryIcon /> },
      ].map((item, index) => (
        <Grid
          item
          xs={6}
          sm={4}
          md={2.4}
          key={index}
          sx={{
            textAlign: "center",
            borderRight: {
              md: index !== 4 ? "1px solid #e5e7eb" : "none",
            },
          }}
        >
          <Box sx={{ color: "#9ca3af", mb: 1.5 }}>
            {item.icon}
          </Box>

          <Typography
            sx={{
              fontWeight: 700,
              fontSize: { xs: "1.8rem", md: "2.2rem" },
              color: "#111827",
            }}
          >
            {loadingMetrics ? "—" : (
              <CountUp
                start={0}
                end={item.value}
                duration={4}
                separator=","
              />
            )}
            +
          </Typography>

          <Typography
            sx={{
              fontSize: "0.9rem",
              color: "#6b7280",
              mt: 0.5,
            }}
          >
            {item.label}
          </Typography>
        </Grid>
      ))}
    </Grid>
  </Box>
</Box>









  <Box sx={{ minHeight: "100vh", bgcolor: "#fff", py: 4,width: '100%', maxWidth: '100%', overflowX: 'hidden' }}>
    {/* {isVisible && (
        <HomeNavbar showHeadings={showHeadings} activeCard={activeCard} />
      )} */}
        {/* Section Title */}
        <Box textAlign="center" mb={4} sx={{ px: { xs: 2, sm: 3, } }}>
          <Typography variant="h3" fontWeight="bold" color="primary">
            What We Offer
          </Typography>
        </Box>
 
        {/* Rows of 3 Cards */}
        {rows.map((rowServices, rowIndex) => (
          <Grid
            container
            spacing={4}
            key={rowIndex}
            className="c-card-row"
            sx={{ 
              // mb: 6,
              px: { xs: 2, sm: 3, md: 4 }, // Responsive padding
              py: { xs: 2, sm: 3, md: 4 },
              mx: {xs:0.1, lg:'auto'},
              maxWidth: { xs:'90%', lg:'90%', xl: '95%', xxl: '85%' }
             }}
          >
            {rowServices.map((service, index) => (
              <Grid
                item
                xs={12}
                md={4}
                key={index}
                display="flex"
                justifyContent="center"
              >
                <Box
                  className="c-card"
                  sx={{
                    width: "100%",
                    minHeight: 400,
                    backgroundColor: "#fff",
                    border: "1px solid #d1d5db",
                    borderRadius: 4,
                    display: "flex",
                    flexDirection: "column",
                    boxShadow: 3,
                    transition: "0.3s",
                    "&:hover": { boxShadow: 6 },
                    position: "relative",
                  }}
                >
                  {/* Top Border Accent */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: -5,
                      right: -5,
                      width: 90,
                      height: 90,
                      zIndex: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        border: "6px solid transparent",
                        borderTopColor: theme.palette.primary.main,
                        borderRightColor: theme.palette.primary.main,
                        borderTopRightRadius: "16px",
                        boxSizing: "border-box",
                      }}
                    />
                  </Box>
 
                  {/* Icon */}
                  <Box
                    sx={{
                      width: 80,
                      height: 80,
                      bgcolor: "#f5f7fa",
                      borderRadius: "16px",
                      boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      p: 1,
                      m: "24px auto 16px auto",
                    }}
                  >
                    <img
                      src={service.icon}
                      alt={service.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </Box>
 
                  {/* Title */}
                  <Typography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    {service.title}
                  </Typography>
                  {service.subtitle && (
                    <Typography
                      variant="body2"
                      color="text.secondary"
                      textAlign="center"
                      mt={0.5}
                    >
                      {service.subtitle}
                    </Typography>
                  )}
 
                  {/* Description */}
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    sx={{ px: 3, mt: 2, flexGrow: 1, textAlign: "center" }}
                  >
                    {service.description}
                  </Typography>
 
                  {/* Button */}
                  <Box textAlign="center" mt={3} mb={3}>
                    <Button
                      variant="outlined"
                      size="small"
                      onClick={() => navigate(service.link)}
                      sx={{
                        width: "140px",
                        borderRadius: 2,
                        width: "140px",
                        borderRadius: 2,
                        textTransform: "none",
                        px: 1,
                        py: 1,
                        zIndex: 3,
                        color: "primary.main",
                        borderColor: "primary.main",
                        "&:hover": {
                          backgroundColor: "primary.main",
                          color: "#fff",
                          borderColor: "primary.main",
                        },
                        px: 1,
                        py: 1,
                        zIndex: 3,
                        color: "primary.main",
                        borderColor: "primary.main",
                        "&:hover": {
                          backgroundColor: "primary.main",
                          color: "#fff",
                          borderColor: "primary.main",
                        },
                      }}
                    >
                      Explore More
                    </Button>
                  </Box>
 
                  {/* Bottom Border Accent */}
                  <Box
                    sx={{
                      position: "absolute",
                      bottom: -5,
                      left: -5,
                      width: 90,
                      height: 90,
                      zIndex: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: "100%",
                        height: "100%",
                        border: "6px solid transparent",
                        borderBottomColor: theme.palette.primary.main,
                        borderLeftColor: theme.palette.primary.main,
                        borderBottomLeftRadius: "16px",
                        boxSizing: "border-box",
                      }}
                    />
                  </Box>
                </Box>
              </Grid>
            ))}
          </Grid>
        ))}
      </Box>





    <Box sx={{ backgroundColor: '#f9fbfd', pb: 2 }}>
      {/* Hero Section */}
   <Box
  sx={{
    background: 'linear-gradient(135deg, #0c3483 0%, #1e88e5 100%)',
    py: 8,
    position: 'relative',
    overflow: 'hidden',
    width: '100%'
  }}
>
  <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4, lg: 6 } }}>
    <Grid container alignItems="center" spacing={4}>
      
      {/* Left Text */}
      <Grid item xs={12} md={6}>
        <Typography 
          variant="h2" 
          sx={{
            color: 'white',
            fontWeight: 600,
            mb: 3,
            fontSize: { xs: '2.2rem', sm: '3rem' },
            lineHeight: 1.2,
          }}
        >
          All Drones{" "}
          <Box 
            component="span" 
            sx={{ 
              color: "#40c4ff",
              background: 'linear-gradient(45deg, #40c4ff, #0288d1)',
              backgroundClip: 'text',
              textFillColor: 'transparent',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
            }}
          >
            One Platform
          </Box>
        </Typography>
        
        <Typography 
          variant="h6" 
          sx={{ 
            color: '#e3f2fd', 
            mb: 4, 
            fontWeight: 300,
          }}
        >
          Certified drones engineered for precision, reliability, and performance across agriculture, commercial, industrial, and enterprise applications
        </Typography>
       
        <Box display="inline-block">
          <Button
            component={Link}
            to="/product/all-drone"
            variant="contained"
            size="large"
            sx={{
              background: "linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)",
              color: "#fff",
              fontWeight: 700,
              px: 4,
              py: 1.5,
              borderRadius: 50,
              textDecoration: "none",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 6px 24px rgba(0,0,0,0.3)",
                background: "linear-gradient(45deg, #2196f3 30%, #1565c0 90%)",
                transform: "translateY(-3px)",
              },
            }}
          >
            Explore Drones
          </Button>
        </Box>
      </Grid>
      
      {/* Right Image */}
      <Grid item xs={12} md={6} sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            maxWidth: 500,
            height: 300,
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
            border: '2px solid rgba(255,255,255,0.1)',
          }}
        >
          <img
            src={HPDronee} // your image path
            alt="Advanced Drone Technology"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "brightness(1.05) contrast(1.1)",
            }}
          />
        </Box>
      </Grid>

    </Grid>
  </Container>
</Box>



      {/* Drone Categories Section */}
   <Container 
  maxWidth="xl" 
  sx={{ 
    py: 8, 
    position: 'relative',
    overflow: 'hidden',
    background: 'linear-gradient(to bottom, #f5f9ff 0%, #ffffff 100%)',
    width: '100%'
  }}
  ref={sectionRef}
>
  {/* Background circles - static */}
  <Box
    sx={{
      position: 'absolute',
      top: '-10%',
      right: '-5%',
      width: '300px',
      height: '300px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(25, 118, 210, 0.1) 0%, rgba(25, 118, 210, 0) 70%)',
      zIndex: 0,
    }}
  />
  
  <Box
    sx={{
      position: 'absolute',
      bottom: '-10%',
      left: '-5%',
      width: '250px',
      height: '250px',
      borderRadius: '50%',
      background: 'radial-gradient(circle, rgba(66, 165, 245, 0.1) 0%, rgba(66, 165, 245, 0) 70%)',
      zIndex: 0,
    }}
  />

  {/* Section title */}
  <Container maxWidth={false} sx={{ px: { xs: 2, sm: 3, md: 4, lg: 6 } }}>
  <Box sx={{ 
    textAlign: 'center', 
    mb: 8,
    position: 'relative',
    zIndex: 1,
  }}>
    <Typography
      variant="h3"
      sx={{
        fontWeight: 800,
        color: "#0d47a1",
        mb: 2,
        position: "relative",
        display: "inline-block",
        "&:after": {
          content: '""',
          position: "absolute",
          bottom: -10,
          left: "50%",
          transform: "translateX(-50%)",
          width: 80,
          height: 4,
          background: "linear-gradient(90deg, #42a5f5 0%, #1e88e5 100%)",
          borderRadius: 2,
        },
      }}
    >
      Find your Drone Segment
    </Typography>

    <Typography 
      variant="h6" 
      sx={{ 
        color: '#546e7a', 
        maxWidth: 700, 
        mx: 'auto', 
        mt: 3,
        lineHeight: 1.6,
      }}
    >
      Discover purpose-built drone categories designed to match your ambition. From agriculture to aerial imaging, find the right drone and elevate your operations
    </Typography>
  </Box>

  {/* Category Cards */}
  <Grid container spacing={4} justifyContent="center">
    {droneCategory.map((item, index) => (
      <Grid 
        item 
        xs={12} 
        sm={6} 
        md={4} 
        lg={3} 
        key={index}
        sx={{ display: 'flex', justifyContent: 'center' }}
      >
        <Card 
          sx={{ 
            height: '100%', 
            display: 'flex', 
            flexDirection: 'column',
            borderRadius: 4,
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(33, 150, 243, 0.15)',
            maxWidth: 320,
            width: '100%',
            position: 'relative',
            '&:before': {
              content: '""',
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              height: 5,
              background: 'linear-gradient(90deg, #42a5f5 0%, #1e88e5 100%)',
              transform: 'scaleX(1)',
              zIndex: 1,
            },
          }}
        >
          <Box sx={{ 
            height: 220, 
            position: 'relative',
            background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)',
            overflow: 'hidden',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            <CardMedia
              component="img"
              sx={{
                height: '80%',
                width: '80%',
                objectFit: 'contain'
              }}
              image={item.image}
              alt={item.name}
            />
          </Box>
          
          <CardContent sx={{ 
            flexGrow: 1, 
            px: 3, 
            py: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center'
          }}>
            <Typography variant="h6" sx={{ 
              fontWeight: 700, 
              color: '#0d47a1',
              mb: 1.5,
              minHeight: 64,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center'
            }}>
              {item.name === "Survey and Inspection Drones" && isSmallScreen
                ? "Survey Drones"
                : item.name}
            </Typography>
            
            <Typography variant="body2" sx={{ 
              color: '#546e7a', 
              mb: 3,
              minHeight: 70,
              lineHeight: 1.6,
              textAlign: 'center'
            }}>
              {item.name === "Agriculture Drones" && "Increase farm productivity, reduce input costs, and manage crops smarter with precision spraying and real-time field insights"}
              {item.name === "Photography Drones" && "Capture high-quality aerial photos and videos with stable flight performance, built to deliver professional results every time"}
              {item.name === "Survey and Inspection Drones" && "Map large areas with precision and inspect infrastructure efficiently using advanced sensors for accurate, data-driven decision-making"}
              {item.name === "Nano Drones" && "Compact and lightweight drones ideal for indoor flying, training sessions, skill development, and easy recreational use"}
            </Typography>
            
            <Button
              variant="contained"
              fullWidth
              sx={{
                background: 'linear-gradient(45deg, #0d47a1 30%, #1976d2 90%)',
                color: 'white',
                fontWeight: 600,
                borderRadius: 2,
                py: 1.5,
                boxShadow: '0 4px 12px rgba(13, 71, 161, 0.3)',
                '&:hover': {
                  background: 'linear-gradient(45deg, #1565c0 30%, #0d47a1 90%)',
                  boxShadow: '0 6px 16px rgba(13, 71, 161, 0.4)',
                }
              }}
              onClick={() => navigate(`/product/${item._id}`)}
            >
              View Details
            </Button>
          </CardContent>
        </Card>
      </Grid>
    ))}
  </Grid>
  </Container>
</Container>


{/* Drone Software Section */}
<Box
  sx={{
    background: "linear-gradient(135deg, #0c3483 0%, #1e88e5 100%)",
    py: 8,
    position: "relative",
    overflow: "hidden",
  }}
>
  <Container maxWidth="lg">
    <Grid container alignItems="center" spacing={4}>
      {/* Left Text */}
      <Grid item xs={12} md={6}>
        <Typography
          variant="h2"
          sx={{
            color: "white",
            fontWeight: 600,
            mb: 3,
            fontSize: { xs: "2.2rem", sm: "3rem" },
            lineHeight: 1.2,
          }}
        >
          Drone{" "}
          <Box
            component="span"
            sx={{
              color: "#40c4ff",
              background: "linear-gradient(45deg, #40c4ff, #0288d1)",
              backgroundClip: "text",
              textFillColor: "transparent",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Software Solution
          </Box>
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: "#e3f2fd",
            mb: 4,
            fontWeight: 300,
          }}
        >
          Access cloud-based Software as a Service (SaaS)  tools for smarter flight planning, accurate mapping, and data insights that drive real business decisions
        </Typography>

        <Box display="inline-block">
          <Button
            component={Link}
            to="/intellegence-market-solutions"
            variant="contained"
            size="large"
            sx={{
              background: "linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)",
              color: "#fff",
              fontWeight: 700,
              px: 4,
              py: 1.5,
              borderRadius: 50,
              textDecoration: "none",
              boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
              transition: "all 0.3s ease",
              "&:hover": {
                boxShadow: "0 6px 24px rgba(0,0,0,0.3)",
                background: "linear-gradient(45deg, #2196f3 30%, #1565c0 90%)",
                transform: "translateY(-3px)",
              },
            }}
          >
            Explore Software
          </Button>
        </Box>
      </Grid>

      {/* Right Image */}
      <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 500,
            height: 300,
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
            border: "2px solid rgba(255,255,255,0.1)",
          }}
        >
          <img
            src={SaaS}
            alt="Drone Software"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              filter: "brightness(1.05) contrast(1.1)",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  </Container>
</Box>




      {/* Drone Parts Section */}
<Box
  sx={{
    py: 4,
    background: "linear-gradient(to bottom, #f0f7ff 0%, #ffffff 100%)",
    position: "relative",
    overflow: "hidden",
    "&:before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      background:
        "radial-gradient(circle, rgba(13,71,161,0.05) 0%, transparent 70%)",
    },
  }}
>
  <Container maxWidth="xl">
    {/* Heading */}
    <Box
      sx={{
        background: "linear-gradient(90deg, #0d47a1 0%, #1976d2 100%)",
        borderRadius: 3,
        p: 2,
        mb: 6,
        textAlign: "center",
        boxShadow: "0 8px 24px rgba(13,71,161,0.2)",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          fontWeight: 700,
          color: "white",
          mb: 0.5,
        }}
      >
        Premium Drone Parts
      </Typography>
      <Typography
        variant="body2"
        sx={{ color: "#e3f2fd" }}
      >
        High-quality components to enhance your drone's performance
      </Typography>
    </Box>

    <Grid container spacing={4} alignItems="center">
      {/* Left Video */}
      <Grid item xs={12} lg={6}>
        <Box
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
            position: "relative",
            height: 400,
            // "&:hover video": {
            //   transform: "scale(1.05)",
            //   transition: "transform 0.6s ease",
            // },
          }}
        >
          <video
            width="100%"
            height="100%"
            autoPlay
            loop
            muted
            playsInline
            style={{
              objectFit: "cover",
              width: "100%",
              height: "100%",
              transition: "transform 0.6s ease",
            }}
          >
            <source src={myVideo} type="video/mp4" />
          </video>
          <Box
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              background:
                "linear-gradient(to top, rgba(13,71,161,0.8) 0%, transparent 100%)",
              color: "white",
              p: 4,
              textAlign: "center",
            }}
          >
            <Typography
              variant="h5"
              sx={{ fontWeight: 600 }}
            >
              Quality Parts for Peak Performance
            </Typography>
          </Box>
        </Box>
      </Grid>

      {/* Right Cards */}
      <Grid item xs={12} lg={6}>
        <Grid container spacing={3}>
          {[
            { name: "Propeller", image: image1, category: "propeller" },
            { name: "Flight Controller", image: image2, category: "flightController" },
            { name: "Accessories", image: image3, category: "accessories" },
            { name: "Motor", image: image4, category: "motor" },
          ].map((part, index) => (
            <Grid item xs={12} sm={6} key={index}>
              <Card
                sx={{
                  height: 180,
                  position: "relative",
                  borderRadius: 3,
                  overflow: "hidden",
                  boxShadow: "0 8px 16px rgba(0,0,0,0.1)",
                  cursor: "pointer",
                  "&:hover": {
                    transform: "translateY(-8px) scale(1.03)",
                    boxShadow: "0 16px 32px rgba(0,0,0,0.2)",
                  },
                  transition: "transform 0.3s, box-shadow 0.3s",
                }}
                onClick={() => handleCategoryClick(part.category)}
              >
                <CardMedia
                  component="img"
                  image={part.image}
                  alt={part.name}
                  sx={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    filter: "brightness(0.9)",
                    transition: "transform 0.5s ease",
                    "&:hover": {
                      transform: "scale(1.08)",
                    },
                  }}
                />
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "50%",
                    background:
                      "linear-gradient(to top, rgba(0,0,0,0.7) 0%, transparent 100%)",
                  }}
                />
                <Typography
                  variant="h6"
                  sx={{
                    position: "absolute",
                    bottom: 16,
                    left: 16,
                    fontWeight: 600,
                    color: "#fff",
                    textShadow: "0 2px 4px rgba(0,0,0,0.5)",
                  }}
                >
                  {part.name}
                </Typography>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Grid>
  </Container>
</Box>


      {/* Training Courses Section */}

      {/* hidden for payment gateway */}
      <Container maxWidth="xl" sx={{ py: 2 }}>
        <Box sx={{ 
            background: 'linear-gradient(90deg, #0d47a1 0%, #1976d2 100%)', 
            borderRadius: 3,
            p: 2, // reduced padding
            mb: 4, // slightly less bottom margin
            textAlign: 'center',
            boxShadow: '0 8px 24px rgba(13,71,161,0.2)'
          }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 0.5 }}>
              Professional Drone Training
            </Typography>
            <Typography variant="body2" sx={{ color: '#e3f2fd' }}>
              Get certified with our industry-leading courses
            </Typography>
          </Box>


        <Grid container spacing={4}>
  {/* First Card (was courses[4]) */}
  {courses && courses[11] && (
    <Grid item xs={12} lg={4}>
      <Card sx={{
        borderRadius: 3,
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        transition: 'transform 0.3s',
        '&:hover': { transform: 'translateY(-5px)' }
      }}>
        <Box sx={{ position: 'relative', height: 200 }}>
          <CardMedia
            component="img"
            image={courses[11].image}
            alt={courses[11].courseName}
            sx={{ height: '100%', width: '100%', objectFit: 'cover' }}
          />
        </Box>
        <CardContent sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1', mb: 1 }}>
            {courses[11].courseName}
          </Typography>
          <Typography variant="body2" sx={{ color: '#546e7a', mb: 2, display: 'flex', alignItems: 'center' }}>
            <PlaceIcon fontSize="small" sx={{ mr: 1 }} /> {courses[12].locationName}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1' }}>
              ₹ {courses[11].price.toLocaleString("en-IN")}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#0d47a1',
                color: '#0d47a1',
                fontWeight: 600,
                borderRadius: 50,
                px: 2,
                '&:hover': { backgroundColor: '#0d47a1', color: 'white' }
              }}
              onClick={() => navigate(`/courses-details/${courses[11]._id}`)}
            >
              Details
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  )}

  {/* Info Box (matched style) */}
  <Grid item xs={12} lg={4} sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ 
              background: 'white', 
              borderRadius: 3, 
              p: 4, 
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
              border: '1px solid #e0e0e0'
            }}>
              <Typography variant="h4" sx={{ 
                fontWeight: 800, 
                mb: 3, 
                color: '#0d47a1',
                textAlign: 'center'
              }}>
                Train. Certify. Succeed.
              </Typography>
              <Typography variant="body1" sx={{ 
                color: '#546e7a', 
                mb: 4, 
                textAlign: 'center',
                lineHeight: 1.8
              }}>
                Gain practical, industry-relevant training designed for beginners and professionals. Learn from certified experts and qualify to operate drones commercially with confidence and credibility
              </Typography>
              <Box sx={{ textAlign: 'center' }}>
              <Button 
                  component={Link}
                  to="/training-courses/0"
                  variant="contained" 
                  sx={{ 
                    background: 'linear-gradient(45deg, #0d47a1 30%, #1976d2 90%)',
                    color: 'white',
                    fontWeight: 600,
                    borderRadius: 50,
                    px: 4,
                    py: 1.5,
                    boxShadow: '0 4px 12px rgba(13,71,161,0.3)',
                    textDecoration: 'none'
                  }}
                >
                  View All Courses
                </Button>
              </Box>
            </Box>
          </Grid>

  {/* Third Card (was courses[5]) */}
  {courses && courses[8] && (
    <Grid item xs={12} lg={4}>
      <Card sx={{
        borderRadius: 3,
        overflow: 'hidden',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
        transition: 'transform 0.3s',
        '&:hover': { transform: 'translateY(-5px)' }
      }}>
        <Box sx={{ position: 'relative', height: 200 }}>
          <CardMedia
            component="img"
            image={courses[8].image}
            alt={courses[8].courseName}
            sx={{ height: '100%', width: '100%', objectFit: 'cover' }}
          />
        </Box>
        <CardContent sx={{ flexGrow: 1, p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1', mb: 1 }}>
            {courses[8].courseName}
          </Typography>
          <Typography variant="body2" sx={{ color: '#546e7a', mb: 2, display: 'flex', alignItems: 'center' }}>
            <PlaceIcon fontSize="small" sx={{ mr: 1 }} /> {courses[8].locationName}
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto' }}>
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1' }}>
              ₹ {courses[8].price.toLocaleString("en-IN")}
            </Typography>
            <Button
              variant="outlined"
              sx={{
                borderColor: '#0d47a1',
                color: '#0d47a1',
                fontWeight: 600,
                borderRadius: 50,
                px: 2,
                '&:hover': { backgroundColor: '#0d47a1', color: 'white' }
              }}
              onClick={() => navigate(`/courses-details/${courses[8]._id}`)}
            >
              Details
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Grid>
  )}
          
          {/* Featured Courses */}
          {courses?.slice(13, 16)?.map((course, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Card sx={{ 
                borderRadius: 3, 
                overflow: 'hidden',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                transition: 'transform 0.3s',
                '&:hover': {
                  transform: 'translateY(-5px)'
                }
              }}>
                <Box sx={{ position: 'relative', height: 200 }}>
                  <CardMedia
                    component="img"
                    image={course?.image || 'defaultImage.jpg'}
                    alt={course?.courseName || 'Default Course'}
                    sx={{ height: '100%', width: '100%', objectFit: 'cover' }}
                  />
                </Box>
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1', mb: 1 }}>
                    {course?.courseName || 'No Name'}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#546e7a', mb: 2, display: 'flex', alignItems: 'center' }}>
                    <PlaceIcon fontSize="small" sx={{ mr: 1 }} /> {course?.locationName || 'No Location'}
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 'auto' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#0d47a1' }}>
                      ₹ {course?.price ? course.price.toLocaleString("en-IN") : '0'}
                    </Typography>
                    <Button
                      variant="outlined"
                      sx={{
                        borderColor: '#0d47a1',
                        color: '#0d47a1',
                        fontWeight: 600,
                        borderRadius: 50,
                        px: 2,
                        '&:hover': {
                          backgroundColor: '#0d47a1',
                          color: 'white'
                        }
                      }}
                      onClick={() => navigate(`/courses-details/${course._id}`)}
                    >
                      Details
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
     {/* Training Institutes Section */}

     {/* hidden for payment gateway */}
      <Container maxWidth="xl" sx={{ py: 2 }}>
      <Box sx={{ 
            background: 'linear-gradient(90deg, #0d47a1 0%, #1976d2 100%)', 
            borderRadius: 3,
            p: 2, // reduced padding
            mb: 4, // slightly less bottom margin
            textAlign: 'center',
            boxShadow: '0 8px 24px rgba(13,71,161,0.2)'
          }}>
            <Typography variant="h4" sx={{ fontWeight: 700, color: 'white', mb: 0.5 }}>
              Train with DGCA-Approved RPTOs         
            </Typography>
            <Typography variant="body2" sx={{ color: '#e3f2fd' }}>
              Train with DGCA-approved RPTOs and earn recognized certification to legally operate drones and build your career
            </Typography>
          </Box>
        <Grid container spacing={4} justifyContent="center">
          {[...filteredInstitutes.slice(0, 3)].map((institute) => (
            <Grid item xs={12} sm={6} md={4} key={institute._id}>
              <Card 
                sx={{ 
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 3,
                  overflow: 'hidden',
                  boxShadow: '0 8px 24px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s',
                  '&:hover': {
                    transform: 'translateY(-8px)'
                  }
                }}
                onClick={() => navigate(`/training-institute/${institute._id}`)}
              >
                <Box sx={{ 
                  height: 200,
                  position: 'relative',
                  background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)'
                }}>
                  <CardMedia
                    component="img"
                    image={institute.image}
                    alt={institute.instituteName}
                    sx={{ 
                      height: '100%', 
                      width: '100%', 
                      objectFit: 'contain',
                      p: 2
                    }}
                  />
                  
                </Box>
                
                <CardContent sx={{ flexGrow: 1, p: 3 }}>
                  <Typography variant="h6" sx={{ 
                    fontWeight: 700, 
                    color: '#0d47a1',
                    mb: 1,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    {institute.instituteName} 
                    <ArrowForwardIcon fontSize="small" sx={{ ml: 1, color: '#1976d2' }} />
                  </Typography>
                  
                  <Typography variant="body2" sx={{ 
                    color: '#546e7a', 
                    mb: 2,
                    display: 'flex',
                    alignItems: 'center'
                  }}>
                    <PlaceIcon fontSize="small" sx={{ mr: 1, color: '#0d47a1' }} /> 
                    {institute.address}
                  </Typography>
                  
                  <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                    <Box sx={{ 
                      backgroundColor: '#e3f2fd', 
                      borderRadius: 3,
                      px: 2,
                      py: 1,
                      mr: 2
                    }}>
                      <Typography variant="body2" sx={{ fontWeight: 700, color: '#0d47a1' }}>
                        4.8 ★
                      </Typography>
                    </Box>
                    <Typography variant="body2" sx={{ color: '#546e7a' }}>
                      120+ Students
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
        
        <Box sx={{ textAlign: 'center', mt: 6 }}>
          <Button
            variant="outlined"
            size="large"
            sx={{
              borderColor: '#0d47a1',
              color: '#0d47a1',
              fontWeight: 600,
              borderRadius: 50,
              px: 5,
              py: 1.5,
              '&:hover': {
                backgroundColor: '#0d47a1',
                color: 'white',
                borderColor: '#0d47a1'
              }
            }}
            onClick={() => navigate('/training-courses/1')}
          >
            View All Institutes
          </Button>
        </Box>
      </Container>




      {/* Drone Quiz Section */}
  {/* <Box
  sx={{
    background: "linear-gradient(135deg, #0c3483 0%, #1e88e5 100%)",
    py: 8,
    position: "relative",
    overflow: "hidden",
  }}
>
  <Container maxWidth="lg">
    <Grid container alignItems="center" spacing={4}>

      <Grid item xs={12} md={6}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 800,
            color: "white",
            mb: 3,
            lineHeight: 1.3,
          }}
        >
          Find Your Perfect{" "}
          <Box
            component="span"
            sx={{
              color: "#40c4ff",
              background: "linear-gradient(45deg, #40c4ff, #0288d1)",
              backgroundClip: "text",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Drone Course
          </Box>
        </Typography>

        <Typography
          variant="h6"
          sx={{
            color: "#e3f2fd",
            mb: 4,
            fontWeight: 300,
            lineHeight: 1.7,
          }}
        >
          Not sure where to start? Take our quick quiz to find the perfect
          course for your drone journey. We'll match you with the best training
          options based on your goals and experience level.
        </Typography>

        <Box display="inline-block">
        <Button
  variant="contained"
  size="large"
  onClick={handleClick}
  sx={{
    background: "linear-gradient(45deg, #42a5f5 30%, #1e88e5 90%)",
    color: "#fff",
    fontWeight: 700,
    px: 4,
    py: 1.5,
    borderRadius: 50,
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
    transition: "all 0.3s ease",
    "&:hover": {
      background: "linear-gradient(45deg, #2196f3 30%, #1565c0 90%)",
      boxShadow: "0 6px 18px rgba(0,0,0,0.3)",
      transform: "translateY(-3px)",
    },
  }}
>
  Start Quiz Now
  <ArrowForwardIcon
    sx={{
      ml: 1,
      transition: "transform 0.3s ease",
      ".MuiButton-root:hover &": { transform: "translateX(4px)" },
    }}
  />
</Button>

        </Box>
      </Grid>


      <Grid item xs={12} md={6} sx={{ display: "flex", justifyContent: "center" }}>
        <Box
          sx={{
            position: "relative",
            width: "100%",
            maxWidth: 500,
            height: 350,
            borderRadius: 4,
            overflow: "hidden",
            boxShadow: "0 12px 28px rgba(0,0,0,0.25)",
            border: "2px solid rgba(255,255,255,0.1)",
          }}
        >
          <CardMedia
            component="img"
            src={require("../../assets/image/png/QUESTION.png")}
            alt="Drone Quiz"
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
              filter: "brightness(1.05) contrast(1.1)",
            }}
          />
        </Box>
      </Grid>
    </Grid>
  </Container>
</Box> */}



    </Box>
      </div>
    </div>
  );
};
export default BuyCertifiedDrone;
